import {IServiceFactory} from "../../../../service-factory.interface";
import {SpecialAssistanceSsrBase} from "../special-assistance-ssr-base";

//Blind customer
export default class BldSsrType extends SpecialAssistanceSsrBase {
    constructor(services: IServiceFactory) {
        super('BLD', services);
    }
}
